export default __webpack_public_path__ + "static/media/afiliadosbrasil.9f10f649.png";